import { useSelector } from "react-redux";
import {
  selectAccountInfo,
  setAccountInfo,
} from "../redux/features/account/accountSlice";
import { useEffect } from "react";
import { selectUser } from "../redux/features/appData";
import {
  apiGetAccountInfo,
  apiIncrementQuestionsAsked,
} from "../services/AccountsService";
import { useDispatch } from "react-redux";

export const useAccount = () => {
  const dispatch = useDispatch();

  const loadAccountInfo = async (userId: string) => {
    const accountInfo = await apiGetAccountInfo(userId);

    if (accountInfo) {
      dispatch(setAccountInfo(accountInfo));
    }
  };

  const increment = async (userId: string) => {
    const accountInfo = await apiIncrementQuestionsAsked(userId);

    if (accountInfo) {
      dispatch(setAccountInfo(accountInfo));
    }
  };

  return {
    loadAccountInfo,
    increment,
  };
};
